import type { IConfDivipola } from '@/modules/Configuracion/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'

export class DivipolaService extends BaseService<IConfDivipola> {
  constructor () {
    super({
      baseUrl: 'system/divipol/'
    })
  }
  async searchByName (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfDivipola[]>>> {
    return this.http.get<IResponseApi<IConfDivipola[]>>('/divipols-by-names', {
      params
    })
  }
}
